import React, { Suspense } from 'react';
import { Route, Switch } from 'react-router-dom';
import Loading from '@/shared/components/Loading';
import { paths } from '@/shared/helpers/paths';
import { ApplicantsPage } from './components/ApplicantsPage';
import './index.scss';

export const dataStarApplicantsBaseUrl = paths.DATA_STAR.APPLICANTS;

const Applicants = () => {
  return (
    <Suspense fallback={<Loading />}>
      <Switch>
        <Route path={dataStarApplicantsBaseUrl} component={ApplicantsPage} />
      </Switch>
    </Suspense>
  );
};

export default Applicants;
